const initailState = {
  subscriptionData: [],
  loadings: false,
};

export function allSubscriptionReducer(
  state = initailState,
  { type, payload }
) {
  switch (type) {
    case "SUBSCRIPTION_VALUE":
      return { ...state, subscriptionData: payload, loadings: false,loading:false };
    case "SHOW_SUBSCRITION_LOADING":
      return { ...state, loadings: true };
    case "HIDE_SUBSCRIPTION_LOADED":
      return { ...state, loadings: false };
    case "SHOW_PAID_SUBSCRITION_LOADING":
      return { ...state, loading: true };
    case "HIDE_PAID_SUBSCRITION_LOADING":
      return { ...state, loading: false };
    case "PAID_SUBSCRIPTION_VALUE":
      return { ...state, loading: false };
    default:
      return state;
  }
}
